import { type PropsWithChildren } from 'react';

import { DiorBanner } from '@debijenkorf/custom-brand-components';

import '@debijenkorf/custom-brand-components/style';

import styles from './DiorLayout.module.scss';

import classNames from 'classnames';

type DiorLayoutProps = {
  isRebrand?: boolean;
};

export const DiorLayout = ({ children, isRebrand }: PropsWithChildren<DiorLayoutProps>) => (
  <div
    className={classNames({
      'theme-dior': !isRebrand,
      'theme-rebrand-dior': isRebrand,
    })}
  >
    <a href="/merk/dior" className={styles.Link}>
      <DiorBanner />
    </a>
    {children}
  </div>
);
